import type { CampaignScreen } from './types';

export const REFERRAL_PROMOTION_VIEWED = 'Referral Promotion - Viewed';

export const REFERRAL_PROMOTION_PRIZE_SELECTED =
  'Referral Promotion - Prize Selected';

export const REFERRAL_PROMOTION_ADD_BUDDY = 'Referral Promotion - Add Buddy';

const PROMOTION_PART_BY_SCREEN: Record<CampaignScreen, 1 | 2 | 3> = {
  poll: 1,
  squad: 2,
  reveal: 3
};

export const promotionPartForScreen = (screen: CampaignScreen): 1 | 2 | 3 =>
  PROMOTION_PART_BY_SCREEN[screen];
